import { render, staticRenderFns } from "./TransportationPlann.vue?vue&type=template&id=0c54699f&scoped=true&"
import script from "./TransportationPlann.vue?vue&type=script&lang=js&"
export * from "./TransportationPlann.vue?vue&type=script&lang=js&"
import style0 from "./TransportationPlann.vue?vue&type=style&index=0&id=0c54699f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c54699f",
  null
  
)

export default component.exports